import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/bottles/form'
import { api, actionCreators } from 'store/modules/bottles'

const metadata = {
  icon: 'glass',
  page: 'bottles',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
